import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useNavHeight from 'hooks/useNavHeight';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import { useSearchContext } from '../../hooks/useSearch';
import usePageNavigation from '../../hooks/usePageNavigation';
import { SEARCH_HEIGHT, SEARCH_HEIGHT_TABLET, DROPDOWN_NAV_HEIGHT } from '../../consts';
import {
  Sticky,
  DropdownNavWrapper,
  StyledDropdownNav,
  Dropdown,
  DropdownTitle,
  SelectedItem,
  Option
} from './styled';

const DropdownNav = ({ questions, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const navHeight = useNavHeight();
  const { width: windowWidth } = useWindowSize();
  const { debouncedSearch } = useSearchContext();

  const searchHeight =
    windowWidth < SCREEN_SIZES.tabletPortrait ? SEARCH_HEIGHT : SEARCH_HEIGHT_TABLET;

  const handleClick = (e) => {
    // close dropdown if user clicks outside of it
    if (dropdownRef?.current?.contains(e.target)) return;
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const scrollOffset = navHeight + searchHeight + DROPDOWN_NAV_HEIGHT + 20 - 1;
  const { activeLinkIndex, createClickHandler } = usePageNavigation(
    questions,
    scrollOffset
  );

  if (debouncedSearch) {
    return <div />;
  }

  return (
    <Sticky bound={navHeight + searchHeight - 1} className={className}>
      <DropdownNavWrapper>
        <StyledDropdownNav className={className} ref={dropdownRef}>
          <SelectedItem onClick={() => setIsOpen(true)} isOpen={isOpen}>
            {questions[activeLinkIndex]?.fields.question}
          </SelectedItem>
          <Dropdown isOpen={isOpen}>
            <DropdownTitle onClick={() => setIsOpen(false)}>
              {questions[activeLinkIndex]?.fields.question}
            </DropdownTitle>
            {questions.map((question, i) => (
              <Option
                key={i}
                href={`#${question.sys.id}`}
                active={i === activeLinkIndex}
                onClick={(e) => {
                  createClickHandler(`question-${question.sys.id}`)(e);
                  setIsOpen(false);
                }}
              >
                {question.fields.question}
              </Option>
            ))}
          </Dropdown>
        </StyledDropdownNav>
      </DropdownNavWrapper>
    </Sticky>
  );
};

DropdownNav.propTypes = {
  className: PropTypes.string,
  questions: PropTypes.array
};

export default DropdownNav;
